"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseYouTubeUrl = void 0;
var YOUTUBE_HOSTS = new Set([
    'youtube.com',
    'www.youtube.com',
    'm.youtube.com',
    'music.youtube.com',
    'youtu.be',
    'www.youtu.be',
]);
var videoEmbed = function (videoId) {
    return "https://www.youtube.com/embed/".concat(encodeURIComponent(videoId));
};
var playlistEmbed = function (playlistId) {
    return "https://www.youtube.com/embed/videoseries?list=".concat(encodeURIComponent(playlistId));
};
/** Channel uploads playlist id is UC… → UU… */
var channelUploadsEmbed = function (channelId) {
    var uploadsId = channelId.startsWith('UC')
        ? "UU".concat(channelId.slice(2))
        : channelId;
    return playlistEmbed(uploadsId);
};
var parseYouTubeUrl = function (raw) {
    var trimmed = raw.trim();
    if (!trimmed) {
        return null;
    }
    var url;
    try {
        url = new URL(trimmed.includes('://') ? trimmed : "https://".concat(trimmed));
    }
    catch (_a) {
        return null;
    }
    var host = url.hostname.toLowerCase();
    if (!YOUTUBE_HOSTS.has(host)) {
        return null;
    }
    var path = url.pathname.replace(/\/+$/, '') || '/';
    if (host === 'youtu.be' || host === 'www.youtu.be') {
        var videoId = path.slice(1).split('/')[0];
        if (videoId) {
            return {
                kind: 'video',
                embedUrl: videoEmbed(videoId),
                suggestedTitle: "YouTube video ".concat(videoId),
            };
        }
        return null;
    }
    var watchId = url.searchParams.get('v');
    if (watchId) {
        return {
            kind: 'video',
            embedUrl: videoEmbed(watchId),
            suggestedTitle: "YouTube video ".concat(watchId),
        };
    }
    var shortsMatch = path.match(/^\/shorts\/([^/]+)/);
    if (shortsMatch) {
        return {
            kind: 'video',
            embedUrl: videoEmbed(shortsMatch[1]),
            suggestedTitle: "YouTube short ".concat(shortsMatch[1]),
        };
    }
    var embedMatch = path.match(/^\/embed\/([^/]+)/);
    if (embedMatch && embedMatch[1] !== 'videoseries') {
        return {
            kind: 'video',
            embedUrl: videoEmbed(embedMatch[1]),
            suggestedTitle: "YouTube video ".concat(embedMatch[1]),
        };
    }
    var listId = url.searchParams.get('list');
    if (listId && (path === '/playlist' || path === '/embed/videoseries' || path === '/watch')) {
        return {
            kind: 'playlist',
            embedUrl: playlistEmbed(listId),
            suggestedTitle: "YouTube playlist ".concat(listId),
        };
    }
    var channelMatch = path.match(/^\/channel\/(UC[\w-]+)/);
    if (channelMatch) {
        return {
            kind: 'channel',
            embedUrl: channelUploadsEmbed(channelMatch[1]),
            suggestedTitle: "YouTube channel ".concat(channelMatch[1]),
        };
    }
    var handleMatch = path.match(/^\/@([\w.-]+)/);
    if (handleMatch) {
        // Official embed needs a playlist/channel id; @handles cannot be resolved without an API.
        // Fall back: open the channel's "live" embed endpoint is not reliable — reject with null
        // so the admin is prompted to paste a video, playlist, or /channel/UC… URL instead.
        // Still allow storing via a synthetic approach using youtube.com/embed with listType=user_uploads
        // only for legacy /user/USERNAME paths (below). For @handles, return null.
        return null;
    }
    var userMatch = path.match(/^\/user\/([^/]+)/);
    if (userMatch) {
        return {
            kind: 'channel',
            embedUrl: "https://www.youtube.com/embed?listType=user_uploads&list=".concat(encodeURIComponent(userMatch[1])),
            suggestedTitle: "YouTube user ".concat(userMatch[1]),
        };
    }
    if (path === '/embed/videoseries' && listId) {
        return {
            kind: 'playlist',
            embedUrl: playlistEmbed(listId),
            suggestedTitle: "YouTube playlist ".concat(listId),
        };
    }
    return null;
};
exports.parseYouTubeUrl = parseYouTubeUrl;
